import { DatePicker, message, Pagination, Popconfirm } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs'
import { deleteStaffpermision, getStaffpermision , staffUpdate} from '../../../api/login/Login'
import { Button } from 'react-bootstrap'
import Loadar from '../../../common/loader/Loader'


function ListStaffPermision() {
    const breadCrumbsTitle = {
        id: "1",
        title_1: "Staff Module",
        title_2: "List Staff",
    }
    const [state, setState] = useState([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(10)
    const [totalCount, setTotalCount] = useState(0)
    const [filters, setFilters] = useState({ name: "", start_date: '', end_date: '' , email:"" , number :'' , type :'' });

    const [updateKey , setUpdateKey] = useState(false)

    const getStaffList = async () => {
        try {
            let obj = {
                page ,
                count,
            }
            if(filters?.start_date)
            {
                obj.start_date = filters?.start_date?.format('YYYY-MM-DD') || ''
            }
            if(filters?.end_date)
                {
                    obj.end_date = filters?.end_date?.format('YYYY-MM-DD') ||''
                }
                if(filters?.name)
                    {
                        obj.name = filters?.name
                    }
                    if(filters?.email)
                        {
                            obj.email = filters?.email
                        }
                        if(filters?.number)
                            {
                                obj.number = filters?.number
                            }   
                            if(filters?.type)
                                {
                                    obj.type = filters?.type
                                }  
            const res = await getStaffpermision(obj)
            setState(res?.data)
            // setPage(pageNum)
            setTotalCount(res?.totalCount)
        } catch (error) {
            alert(error?.message)
        }
    }

    useEffect(() => {
        getStaffList()
    }, [page , updateKey])

    const deleteStaff = async (id) => {
        setLoading(true)
        try {
            await deleteStaffpermision(id)
            // const newPage = totalCount % count === 1 ? page - 1 : page
            // getStaffList(newPage)
            setUpdateKey((pre)=>!pre)
        } catch (error) {
            alert(error.message)
        }
        setLoading(false)
    }

    const confirm = (id) => {
        deleteStaff(id)
        message.success('Delete Successful!')
    }

    const cancel = () => {
        message.error('Cancel Successful!')
    }

    const onChangeVal = (pageNum) => {
        // getStaffList(pageNum - 1)
        setPage(pageNum - 1)
    }



    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
      };

      const handleDateChange = (field, date) => {
        setFilters({ ...filters, [field]: date });
      };  

    const applyFilter = () => {
        setPage(0)
        setUpdateKey((pre)=>!pre)
    };

    const handleReset = ()=>{
        setFilters({ name: "", start_date: '', end_date: '' , email:"" , number :'' , type :'' })
        setPage(0)
        setUpdateKey((pre)=>!pre)
    }

   

    const updateActiveStatus = async(item) => {
       
        setLoading(true)
        let body = {
            email : item?.email,
            status : item?.status ? false : true
        }
        try {
            let res = await staffUpdate(item?._id , body)
            setUpdateKey((pre)=>!pre)
        } catch (error) {
            
        } finally {
            setLoading(false)
        }
    }
  

    return (
        <>
            <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />

        {/* //filter start */}

  <div className="row m-4">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-responsive active-projects style-1">
                                <div className="tbl-caption tbl-caption-2">
                                    <h4 className="heading mb-0"><b>{' Staff List Search '} </b></h4>
                                </div>
                                <div className="row pt-2 gy-3">
                                 
                                    <div className="col-md-4">
        <label>Start Date</label>
        <DatePicker
          value={filters.start_date}
          
          onChange={(date) => handleDateChange("start_date", date)}
          disabledDate={(current) => current && current > new Date()}
          placeholder="Select start date"
          className="custom-datepicker form-control"
        />
      </div>

      <div className="col-md-4">
        <label>End Date</label>
        <DatePicker
          value={filters.end_date}
          onChange={(date) => handleDateChange("end_date", date)}
          disabledDate={(current) => current && current > new Date()}
          placeholder="Select end date"
          className="custom-datepicker form-control"
        />
      </div>
      <div className="col-md-4">
                                        <label>Name</label>
                                        <input type="text" name="name" placeholder='Enter Name' value={filters?.name} className="form-control" onChange={handleFilterChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Email</label>
                                        <input type="email" name="email" placeholder='Enter email' value={filters?.email} className="form-control" onChange={handleFilterChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Mobile Number</label>
                                        <input type="number" name="number" value={filters?.number} className="form-control" onChange={handleFilterChange} placeholder='Enter 10-digit mobile number' />
                                    </div>
                                    <div className="col-md-4">
                                        <label>KYC Status</label>
                                        <select className="form-select"  value={filters?.type} name="type" onChange={handleFilterChange}>
                                            <option value=''>Select Type</option>
                                            
                                                <option value='Approved'>Approved</option>
                                                <option value='Pending'>Pending</option>
                                    
                                        </select>
                                    </div>

                                    <div className="col-md-12 mt-3">
                                        <button className="btn btn-primary" onClick={applyFilter}>Submit</button>
                                        <button className="btn btn-info ml-3" onClick={handleReset}>Reset</button>
                                    </div>
                                </div>
                        
                                </div>
                                </div>
                                </div>
                                </div>
                                </div>
          {/* {filter end} */}


            <div className="row m-4">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-responsive active-projects style-1">
                                <div className="tbl-caption">
                                    <h4 className="heading mb-0">Staff List</h4>
                                    <div>
                                        <Link className="btn btn-primary btn-sm" to="/admin/add-staff" role="button" aria-controls="offcanvasExample">+ ADD STAFF</Link>
                                    </div>
                                </div>
                                <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer">
                                    <div className="dt-buttons">
                                        <button className="dt-button buttons-excel buttons-html5 btn btn-sm border-0" tabIndex={0} aria-controls="empoloyees-tblwrapper" type="button">
                                            <span><i className="fa-solid fa-file-excel" /> Export Report</span>
                                        </button>
                                    </div>
                                    <table id="empoloyees-tblwrapper" className="table dataTable no-footer" role="grid" aria-describedby="empoloyees-tblwrapper_info">
                                        <thead>
                                            <tr role="row">
                                                <th style={{ width: '50px' }}>S.No</th>
                                                <th style={{ width: '50px' }}>Date</th>
                                                <th style={{ width: '200px' }}>Name</th>
                                                <th style={{ width: '200px' }}>Email</th>
                                                <th style={{ width: '150px' }}>Phone</th>
                                                <th style={{ width: '100px' }}>Role</th>
                                                <th style={{ width: '100px' }}>Floor</th>
                                                <th style={{ width: '100px' }}>Area</th>
                                                <th style={{ width: '100px' }}>Building</th>
                                                <th style={{ width: '100px' }}>Block</th>
                                                <th style={{ width: '100px' }}>Office</th>
                                                <th style={{ width: '100px' }}>Ward</th>
                                                <th style={{ width: '100px' }}>Department</th>
                                                <th style={{ width: '100px' }}>Designation</th>
                                                <th style={{ width: '100px' }}>Status</th>
                                                <th style={{ width: '150px' }}>KYC Status</th>
                                                <th style={{ width: '150px' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {state?.map((item, i) => (
                                                <tr key={item._id}>
                                                    <td>{(i + 1) + page * count}</td>
                                                    <td>{item?.createdAt}</td>
                                                    <td>{item?.name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile}</td>
                                                    <td>{item?.role_name}</td>
                                                    <td>{item?.floor_id}</td>
                                                    <td>{item?.area_id}</td>
                                                    <td>{item?.building_id}</td>
                                                    <td>{item?.block_id}</td>
                                                    <td>{item?.office_id}</td>
                                                    <td>{item?.ward_id}</td>
                                                    <td>{item?.department_id}</td>
                                                    <td>{item?.designation_id}</td>
                                                    <td>
                                                        <button onClick={()=>updateActiveStatus(item)} className= {item?.status ? `btn btn-success  w-100`:`btn btn-danger w-100` }>
                                                        {item?.status ? 'Active ':"Deactived "}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        {item?.is_approved ==='Approved' ? (
                                                            <Link to={`/admin/staff-kyc_details/${item?._id}`} className='btn btn-success w-100'>
                                                                {item.is_approved}
                                                            </Link>
                                                        ) : (
                                                            <Link to={`/admin/staff-kyc_details/${item?._id}`} className='btn btn-warning w-100'>
                                                                Pending
                                                            </Link>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <Link to={`/admin/update-staff/${item?._id}`} className="btn btn-primary shadow btn-xs sharp me-1"><i className="fa fa-pencil" /></Link>
                                                            <Popconfirm
                                                                title="Delete Staff !"
                                                                description="Are you sure to delete ?"
                                                                onConfirm={() => confirm(item?._id)}
                                                                onCancel={cancel}
                                                                okText="Yes"
                                                                cancelText="No"
                                                            >
                                                                <Button className="btn btn-danger shadow btn-xs sharp"><i className="fa fa-trash" /></Button>
                                                            </Popconfirm>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                        Total {totalCount} entries
                                    </div>
                                    <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                        <Pagination
                                            //    showSizeChanger
                                            //    onShowSizeChange={''}
                                          current={page+1}
                                            // defaultCurrent={1}
                                            onChange={onChangeVal}
                                            total={totalCount}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <Loadar />}
        </>
    )
}

export default ListStaffPermision
